import { ApiError, QueryKeys, SmartAction } from '@connect-x-app/shared-domain-models';
import { getSmartActions } from '@connect-x-app/web-data-access';
import { useQuery } from '@tanstack/react-query';

export const useSmartActions = () =>
  useQuery<SmartAction[], ApiError>({ queryFn: getSmartActions, queryKey: [QueryKeys.SMART_ACTIONS] });
